export const MAX_NUMBER_OF_FILES = 10;
export const MAX_FILE_SIZE_IN_BYTES = 33554433; // 32MB
export const ALLOWED_FILE_TYPES = ['image/*', '.pdf', '.xlsx', '.csv', '.txt'];
